import {
    ADD_SELECTED_LAYER_TO_PRINT,
    REMOVE_SELECTED_LAYER_FROM_PRINT,
    SET_SELECTED_BASE_LAYER_PRINT
} from './Types';

export const addSelectedLayer = (systemName: string) => {
    return {
        type: ADD_SELECTED_LAYER_TO_PRINT,
        systemName
    };
};

export const removeSelectedLayer = (systemName:string) => {
    return {
        type: REMOVE_SELECTED_LAYER_FROM_PRINT,
        systemName
    };
};

export const setSelectedBaseLayer = (systemName:string) => {
    return {
        type: SET_SELECTED_BASE_LAYER_PRINT,
        systemName
    };
};